import { defineStore } from 'pinia'

export const ShowJsonInCards = defineStore('dev_card_json', {
    state: () => {
        return { dev_card_json: false }
    },
    actions: {
        get() {
            return this.dev_card_json
        },
        set(data) {
            this.dev_card_json = data
        }
    },
})

export const AutoSave = defineStore('dev_autosave', {
    state: () => {
        return { dev_autosave: false }
    },
    actions: {
        get() {
            return this.dev_autosave
        },
        set(data) {
            this.dev_autosave = data
        }
    },
})

export const ExternalData = defineStore('dev_ed', {
    state: () => {
        return { dev_ed: false }
    },
    actions: {
        get() {
            return this.dev_ed
        },
        set(data) {
            this.dev_ed = data
        }
    },
})

export const DevTabs = defineStore('dev_tabs', {
    state: () => {
        return { dev_tabs: false }
    },
    actions: {
        get() {
            return this.dev_tabs
        },
        set(data) {
            this.dev_tabs = data
        }
    },
})